import {DateService} from '@services/date.service';

export interface ShortLinkConfig {
    label: string;
    daysShift?: number;
    monthsShift?: number;
}

export class DateRangeShortLink {
    label: string;
    datesRangeLabel: string;
    dateFrom: Date;
    dateTo: Date;

    constructor(
        private config: ShortLinkConfig,
    ) {
        this.label = this.config.label;
        this.setAttributes();
    }

    private setAttributes() {
        this.setDates();
    }

    private setDates() {
        const daysShift = this.config.daysShift || 0;
        const monthsShift = this.config.monthsShift || 0;

        const today = new Date();
        let dateB = new Date();

        if (monthsShift) {
            dateB = DateService.addMonths(dateB, monthsShift);
        }

        if (daysShift) {
            dateB = DateService.addDays(dateB, daysShift);
        }

        if (today.getTime() === dateB.getTime()) {
            this.dateFrom = today;
            this.dateTo = dateB;
            this.datesRangeLabel = DateService.dateToFormat(this.dateFrom);
            return;
        }

        const diff = today.getTime() - dateB.getTime();

        /**
         * Если начало в прошлом, а окончание сегодня
         */
        if (diff > 0) {
            /**
             * Если разница менее одного дня, значит берем "Вчера"
             */
            if (diff <= DateService.oneDayTime) {
                this.dateFrom = dateB;
                this.dateTo = dateB;
                this.datesRangeLabel = DateService.dateToFormat(this.dateFrom);
                return;
            }

            if (diff > DateService.oneDayTime) {
                this.dateFrom = dateB;
                this.dateTo = today;
                this.datesRangeLabel = DateService.dateToFormat(this.dateFrom) + ' - ' + DateService.dateToFormat(this.dateTo);
                return;
            }
        } else {
            if (diff * (-1) <= DateService.oneDayTime) {
                this.dateFrom = dateB;
                this.dateTo = dateB;
                this.datesRangeLabel = DateService.dateToFormat(this.dateFrom);
                return;
            }

            if (diff * (-1) > DateService.oneDayTime) {
                this.dateFrom = today;
                this.dateTo = dateB;
                this.datesRangeLabel = DateService.dateToFormat(this.dateFrom) + ' - ' + DateService.dateToFormat(this.dateTo);
                return;
            }
        }
    }
}
